import plus_circle from "../../assets/svg/plus-circle.svg";
import AsyncSelect from 'react-select/async';
import download_arrow from "../../assets/svg/download_arrow.svg";
import upload_icon from "../../assets/svg/upload_icon.svg";
import excel_icon from "../../assets/svg/excel_icon.svg";
import small_line from "../../assets/svg/small_line.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import React, { useState, useEffect, useRef } from "react"
import plus_icon from "../../assets/svg/plus_icon.svg";
import axiosInstance from '../../axiosInstance';
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";


const CreateJobs = ({ onClose, onJobCreated, projectId: initialProjectId, projectName: initialProjectName, selectedJobId: existingJobId }) => {

  const [isUploadPopupOpen, setIsUploadPopupOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedproject, setselectedproject] = useState(0);
  const [showPopup, setShowPopup] = useState(false)
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [showProjectSuggestions, setShowProjectSuggestions] = useState(false);
  const dropdownRef = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [jobOptions, setJobOptions] = useState([]);
  const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
  const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
  const [inputValues, setInputValues] = useState({});

  const [projectId, setselectedprojectId] = useState(initialProjectId || 0);
  const [projectInput, setProjectInput] = useState(initialProjectName || "");
  const [selectedChargeIds, setSelectedChargeIds] = useState({});


  const [isEdit, setIsEdit] = useState(false);
  const [jobId, setJobId] = useState(0);

  const [jobid, setjobid] = useState(0);


  const navigate = useNavigate();
  const locationData = useLocation();
  const job_data = locationData.state?.job_data || {};
  const data = job_data?.data || {};

  const contract_id = data.contract_id;
  console.log("contract_id", contract_id);


  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
    console.log("data", data);
  }, [data?.job_id]);


  // Edit
  useEffect(() => {
    console.log("Edit use effect called with data:", data);
    const loadEditData = async () => {
      try {
        if (data && Object.keys(data).length > 0) {
          console.log("inside of data use effect");
          setIsEdit(true);
          setjobid(data.job_id);

          setFormData({
            project_id: data.project_id || "",
            job_no: data.job_no || "",
            job_type_id: data.job_type_id || "",
            job_created_date: data.created_date?.split(" ")[0] || '',
          });
          console.log("Form data set to:", data.project_id, data.job_type_id);

          // setProjectInput(data.project_name);
          // setselectedproject(data.project_id);
          // setselectedprojectId(data.project_id);

          // const projectResponse = await axios.get(
          //   "https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion",
          //   { params: { query: "" } }
          // );

          const projectResponse = await axiosInstance.get(
            "/costsolution/projects/autosuggestion",
            { params: { query: "" } }
          );

          if (projectResponse.data?.autosuggestion) {
            const options = projectResponse.data.autosuggestion;
            setProjectOptions(options);

            const selected = options.find(item => item.value === data.project_id);
            if (selected) {
              setProjectInput(selected.label);
              setselectedproject(selected.value);
              setselectedprojectId(selected.value);
            }
          }

          if (data.project_id) {
            // const jobResponse = await axios.get(
            //   `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getJobTypes/${data.project_id}`
            // );

            const jobResponse = await axiosInstance.get(
              `/project_based/getJobTypes/${data.project_id}`
            );

            if (jobResponse.data && Array.isArray(jobResponse.data.jobtypes)) {
              setJobOptions(jobResponse.data.jobtypes);
            }
          }

          if (data.chargelines && Array.isArray(data.chargelines)) {
            let mappedCategories = [{
              id: data.job_type_id,
              job_type_name: data.job_type_name || "",
              rows: data.chargelines.map((line, index) => ({
                charge_id: line.charge_id || index + 1,
                description: line.description_of_charges || "",
                unitQuantity: parseFloat(line.unit_of_quantity) || 0,
                unitRatePrice: parseFloat(line.unit_of_rate) || 0,
                netTotal: parseFloat(line.net_total) || 0,
                chargecode: line.charge_name || "",
                isChecked: false,
                elements: "",
                remarks: "",
                attachment_url: line.attachment_url || ""
              }))
            }];

            // const chargeCodeResponse = await axios.get(
            //   `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${data.project_id}`
            // );

            const chargeCodeResponse = await axiosInstance.get(
              `/project_based/getchargecodes/${data.project_id}`
            );

            if (chargeCodeResponse.data?.chargecodes) {
              console.log("inside charge code");
              console.log("Charge Code List:", chargeCodeResponse.data.chargecodes);
              const chargeList = chargeCodeResponse.data.chargecodes;

              mappedCategories = mappedCategories.map(category => ({
                ...category,
                rows: category.rows.map(row => {
                  const matched = chargeList.find(code => Number(code.value) === Number(row.charge_id));
                  return {
                    ...row,
                    chargecode: matched ? matched.label : row.chargecode
                  };
                })
              }));
            }

            setAllCategories(mappedCategories);
            setSelectedJobs([data.job_type_id]);
            console.log("selectedJobs updated: ", [data.job_type_id]);

            const initialInputValues = {};
            const initialSelectedChargeIds = {};

            mappedCategories.forEach((category, catIndex) => {
              initialInputValues[catIndex] = {};
              category.rows.forEach((row, rowIndex) => {
                initialInputValues[catIndex][rowIndex] = row.chargecode || "";
                initialSelectedChargeIds[`${catIndex}_${rowIndex}`] = row.charge_id || 0;
              });
            });

            setInputValues(initialInputValues);
            setSelectedChargeIds(initialSelectedChargeIds);
          }
        }
      } catch (error) {
        console.error("Error loading edit data:", error);
      }
    };

    loadEditData();
  }, [data?.job_id]);

  const loadProjectOptions = async (inputValue, callback) => {
    console.log("Searching for projects with:", inputValue);

    try {
      // const res = await axios.get(
      //     "https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion",
      //     {
      //         params: { term: inputValue || '' },
      //         headers: { "Content-Type": "application/json" },
      //     }
      // );

      const res = await axiosInstance.get(
        "/costsolution/projects/autosuggestion",
        {
          params: { term: inputValue || '' },
        }
      );

      const projects = res.data?.autosuggestion || [];

      // Filter so only uppercase matching labels are returned
      const filtered = projects.filter(item =>
        item.label.toUpperCase().includes(inputValue.toUpperCase())
      );

      const mapped = filtered.map((item) => ({
        label: item.label,
        value: item.value,
      }));

      console.log("Filtered + Mapped project options:", mapped);
      callback(mapped);
    } catch (error) {
      console.error("Project suggestion error:", error);
      callback([]);
    }
  };











  const jobData = [
    {
      id: "83939930",
      name: "83939930",
      categories: [
        {
          id: 1,
          name: "Category 1",
          quantity: 340,
          rate: 45000,
          netValue: 67000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        },
      ]
    },
    {
      id: "53939930",
      name: "53939930",
      categories: [
        {
          id: 2,
          name: "Category 2",
          quantity: 210,
          rate: 32000,
          netValue: 67200,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "23939930",
      name: "23939930",
      categories: [
        {
          id: 3,
          name: "Category 3",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "743930290",
      name: "743930290",
      categories: [
        {
          id: 4,
          name: "Category 4",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "938493809",
      name: "938493809",
      categories: [
        {
          id: 5,
          name: "Category 5",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        },

      ]
    },
    {
      id: "793849380",
      name: "793849380",
      categories: [
        {
          id: 6,
          name: "Category 6",
          quantity: 340,
          rate: 45000,
          netValue: 67000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
  ];

  // const jobOptions = [
  //   { id: "743930290", name: "743930290", job_type_id: 1 },
  //   { id: "938493809", name: "938493809", job_type_id: 2 },
  //   { id: "793849380", name: "793849380", job_type_id: 3 },
  //   { id: "83939930", name: "83939930", job_type_id: 4 },
  //   { id: "53939930", name: "53939930", job_type_id: 5 },
  //   { id: "23939930", name: "23939930", job_type_id: 6 }
  // ];

  const [allCategories, setAllCategories] = useState([]);

  // When selected jobs change, update the categories


  const addRow = (categoryId) => {
    setAllCategories(prevCategories =>
      prevCategories.map((category, index) =>
        index === categoryId
          ? {
            ...category,
            rows: [
              ...category.rows,
              {
                billingtype: "",
                chargecode: "",
                elements: "",
                description: "",
                unitQuantity: "",
                unitRatePrice: "",
                netTotal: "",
                attachment: "",
                uploadedFiles: [],
                isChecked: false
              },
            ],
          }
          : category
      )
    );
  };

  const handleFileUpload = (e, categoryId, index, lineindex) => {
    const files = Array.from(e.target.files);

    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? { ...row, uploadedFiles: [...(row.uploadedFiles || []), ...files] }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveFile = (categoryId, index, lineindex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  uploadedFiles: row.uploadedFiles.filter((_, idx) => idx !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };



  const handleRemoveAttachment = (categoryId, index, lineindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? { ...row, attachment: "" }
                : row
            ),
          }
          : category
      )
    );
  };


  const handleInputChange = (e, index, rowIndex, field) => {
    const { value } = e.target;

    setAllCategories(prevCategories =>
      prevCategories.map((category, currentindex) => {
        if (currentindex !== index) return category;

        // Update the specific row
        const updatedRows = category.rows.map((row, i) => {
          if (i === rowIndex) {
            const updatedRow = { ...row, [field]: value };

            if (field === 'unitQuantity' || field === 'unitRatePrice') {
              const quantity = parseFloat(updatedRow.unitQuantity) || 0;
              const rate = parseFloat(updatedRow.unitRatePrice) || 0;
              updatedRow.netTotal = (quantity * rate).toString();
            }

            return updatedRow;
          }
          return row;
        });

        // Recalculate summary after updating rows
        const totalQuantity = updatedRows.reduce((sum, r) => sum + (parseFloat(r.unitQuantity) || 0), 0);
        const totalRate = updatedRows.reduce((sum, r) => sum + (parseFloat(r.unitRatePrice) || 0), 0);
        const totalNetValue = updatedRows.reduce((sum, r) => sum + (parseFloat(r.netTotal) || 0), 0);

        return {
          ...category,
          rows: updatedRows,
          quantity: totalQuantity.toFixed(2),
          rate: totalRate.toFixed(2),
          netValue: totalNetValue.toFixed(2)
        };
      })
    );
  };


  const deleteRow = (categoryId, rowIndex) => {
    const categoryIndex = allCategories.findIndex(cat => cat.id === categoryId);

    if (categoryIndex === -1) {
      return; // Category not found, should not happen but good to check
    }

    const category = allCategories[categoryIndex];

    if (category.rows.length <= 1) {
      toast.error("At least one row must remain, cannot delete.");
      return;
    }

    setAllCategories(prevCategories =>
      prevCategories.map(cat => {
        if (cat.id === categoryId) {
          const newRows = [...cat.rows];
          newRows.splice(rowIndex, 1);
          return { ...cat, rows: newRows };
        }
        return cat;
      })
    );

    setInputValues(prevInputValues => {
      const newInputValues = { ...prevInputValues };
      if (newInputValues[categoryIndex]) {
        const rows = { ...newInputValues[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newInputValues[categoryIndex] = shiftedRows;
      }
      return newInputValues;
    });

    setSelectedChargeIds(prevSelectedChargeIds => {
      const newSelectedChargeIds = {};
      Object.keys(prevSelectedChargeIds).forEach(key => {
        const [catIndexStr, rowIdxStr] = key.split('_');
        const catIndex = Number(catIndexStr);
        const rowIdx = Number(rowIdxStr);

        if (catIndex === categoryIndex) {
          if (rowIdx < rowIndex) {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          } else if (rowIdx > rowIndex) {
            newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
          }
          // If rowIdx === rowIndex, we simply skip it (the deleted row)
        } else {
          newSelectedChargeIds[key] = prevSelectedChargeIds[key];
        }
      });
      return newSelectedChargeIds;
    });

    setSuggestionsMap(prev => {
      const newMap = { ...prev };
      if (newMap[categoryIndex]) {
        const rows = { ...newMap[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newMap[categoryIndex] = shiftedRows;
      }
      return newMap;
    });
  };


  const toggleJobDropdown = () => {
    setIsJobDropdownOpen(!isJobDropdownOpen);
  };

  const handleJobCheckboxChange = (jobId) => {
    if (selectedJobs.includes(jobId)) {
      // Unchecking: cleanup related data
      handleRemoveJob(jobId);
    } else {
      // Selecting: only allow one job type at a time
      if (selectedJobs.length > 0) {
        const prevJobId = selectedJobs[0];
        handleRemoveJob(prevJobId); // remove old one first
      }
      setSelectedJobs([jobId]);
    }
  };

  const handleRemoveJob = (jobIdToRemove) => {
    setSelectedJobs(prevSelectedJobs => {
      const jobIndexToRemove = prevSelectedJobs.findIndex(id => id === jobIdToRemove);

      // Remove categories
      setAllCategories(prev => {
        const jobToRemove = jobData.find(j => j.id === jobIdToRemove);
        if (!jobToRemove) return prev;

        const categoryIdsToRemove = jobToRemove.categories.map(c => c.id);
        return prev.filter(cat => !categoryIdsToRemove.includes(cat.id));
      });

      // Clear charge code input fields
      setInputValues(prev => {
        const newInputValues = { ...prev };
        delete newInputValues[jobIndexToRemove];
        return newInputValues;
      });

      // Clear selected charge IDs
      setSelectedChargeIds(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          if (key.startsWith(`${jobIndexToRemove}_`)) {
            delete updated[key];
          }
        });
        return updated;
      });

      // Clear suggestion visibility map
      setShowSuggestionsMap(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          if (key.startsWith(`${jobIndexToRemove}_`)) {
            delete updated[key];
          }
        });
        return updated;
      });

      // Return updated job selection
      return prevSelectedJobs.filter(id => id !== jobIdToRemove);
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsJobDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const [formData, setFormData] = useState({
    project_id: "",
    job_no: "",
    job_type_id: "",
    job_created_date: "",
  });


  const handleDateChange = (e) => {
    setFormData({ ...formData, job_created_date: e.target.value });
  };

  // In CreateJobs.js - Update the handleSubmit function
  const handleSubmit = async (actionType = "submit") => {
    // Validation checks
    if (!projectInput.trim()) {
      toast.error("Project Code is required");
      return;
    }
    if (selectedJobs.length === 0) {
      toast.error("At least one Job Type is required");
      return;
    }
    if (!formData.job_created_date) {
      toast.error("Date is required");
      return;
    }

    if (actionType === "submit") {
      const confirmed = window.confirm("Are you sure you want to submit the job?");
      if (!confirmed) return;
    }

    try {
      // Prepare the job data for submission
      const submitData = {
        actions: [actionType],
        jobs: allCategories.map((category, categoryIndex) => ({
          project_id: parseInt(formData.project_id) || 0,
          job_type_id: parseInt(category.id) || 0,
          job_created_date: formData.job_created_date || "",
          accrual: category.rows.reduce((sum, row) => sum + (parseFloat(row.netTotal) || 0), 0),
          job_line: category.rows
            .filter(row => row.description || row.unitQuantity || row.unitRatePrice || row.uploadedFiles?.length)
            .map((row, index) => ({
              project_id: parseInt(formData.project_id) || 0,
              job_type_id: parseInt(category.id) || 0,
              charge_id: selectedChargeIds[`${categoryIndex}_${index}`] || 0,
              charge_code: row.chargecode || "",
              description_of_charges: row.description || "",
              unit_of_quantity: parseFloat(row.unitQuantity) || 0,
              unit_of_rate: parseFloat(row.unitRatePrice) || 0,
              net_total: parseFloat(row.netTotal) || 0,
              accrual: parseFloat(row.netTotal) || 0,
              attachment_key: `${categoryIndex}_${index}`
            }))
        })).filter(job => job.job_line.length > 0)
      };

      // Prepare form data with attachments
      const formDataPayload = new FormData();
      formDataPayload.append('data', JSON.stringify(submitData));

      // Add attachments to form data
      allCategories.forEach((category, categoryIndex) => {
        category.rows.forEach((row, rowIndex) => {
          if (row.uploadedFiles?.length) {
            row.uploadedFiles.forEach((file) => {
              formDataPayload.append(`attachments[${categoryIndex}_${rowIndex}][]`, file);
            });
          }
        });
      });

      // Submit to API
      const response = await axiosInstance.post('/job/save', formDataPayload, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data && response.data.success) {
        toast.success(`Job ${actionType === "save" ? "saved" : "submitted"} successfully!`);

        // Prepare the complete job data to pass back to parent
        const jobData = {
          jobNo: response.data.job_no || response.data.data?.job_no || '',
          job_type_id: selectedJobs[0],
          project_id: formData.project_id,
          project_name: projectInput,
          rows: allCategories.flatMap(category =>
            category.rows.map(row => ({
              chargecode: row.chargecode,
              description: row.description,
              unitQuantity: row.unitQuantity,
              unitRatePrice: row.unitRatePrice,
              netTotal: row.netTotal,
              attachment: row.attachment
            }))
          )
        };

        if (response.data && response.data.success) {
          toast.success(`Job ${actionType === "save" ? "saved" : "submitted"} successfully!`);

          const newJobId = response.data.job_id; // Adjust if the key is different
          const updatedJobIds = [...existingJobId, newJobId];
          console.log("newJobId", newJobId);
          console.log("updatedJobIds", updatedJobIds);

          // Optionally call parent callback
          if (onJobCreated) {
            onJobCreated(jobData);
          }

          if (onClose) {
            onClose();
          }

          // Now call the generate invoice API
          try {
            const invoicePayload = { job_ids: updatedJobIds };
            const invoiceResponse = await axiosInstance.post('/job/generate_invoice', invoicePayload);

            if (invoiceResponse.data.success) {
              navigate("/invoice_addNew", {
                state: {
                  invoiceData: invoiceResponse.data,
                  selectedJobs: updatedJobIds
                }
              });
            } else {
              toast.error("Failed to generate invoice data");
            }
          } catch (invoiceError) {
            console.error("Error generating invoice:", invoiceError);
            toast.error(invoiceError.response?.data?.message || "Invoice generation failed");
          }

          // Reset form (optional)
          setFormData(prev => ({
            ...prev,
            job_no: "",
            job_type_id: "",
            job_created_date: new Date().toISOString().split('T')[0]
          }));
          setSelectedJobs([]);
          setAllCategories([]);
        }

      } else {
        throw new Error(response.data?.message || 'Failed to submit job');
      }
    } catch (error) {
      console.error('Error submitting job:', error);
      const errorMessage = error.response?.data?.message ||
        error.message ||
        `Failed to ${actionType} job`;
      toast.error(errorMessage);
    }
  };


  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // const response = await axios.get("https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion");
        const response = await axiosInstance.get("/costsolution/projects/autosuggestion");
        if (response.data) {
          setProjectOptions(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch projects:", error);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    if (initialProjectId && initialProjectName) {
      setFormData(prev => ({
        ...prev,
        project_id: initialProjectId,
        project_name: initialProjectName
      }));
      setselectedprojectId(initialProjectId);
      setProjectInput(initialProjectName);

      // Also load job types for this project
      const fetchJobs = async () => {
        try {
          const response = await axiosInstance.get(
            `/project_based/getJobTypes/${initialProjectId}`
          );
          if (response.data?.jobtypes) {
            setJobOptions(response.data.jobtypes);
          }
        } catch (error) {
          console.error("Failed to fetch job options:", error);
        }
      };
      fetchJobs();
    }
  }, [initialProjectId, initialProjectName]);

  const handleProjectSelect = (project) => {
    setFormData({
      ...formData,
      project_id: project.value,
      project_name: project.label,
    });
    setShowProjectSuggestions(false);
  };



  useEffect(() => {
    const newCategories = [];

    selectedJobs.forEach((jobValue) => {
      let jobObject = {};  // Declare inside the loop

      if (data && Array.isArray(data.chargelines)) {
        // Filter matching job types
        const jobLines = data.chargelines.filter(line => line.job_type_id === jobValue);

        if (jobLines.length > 0) {
          jobObject = {
            id: jobValue,
            name: jobLines[0].job_type_name || `Category ${jobValue}`,
            rows: jobLines.map(line => ({
              billingtype: "",
              elements: "",
              remarks: "",
              description: line.description_of_charges || "",
              contract_charge_line_table_id: line.contract_charge_line_table_id || null,
              unitQuantity: line.unit_of_quantity || "",
              unitRatePrice: line.unit_of_rate || "",
              netTotal: line.net_total || "",
              attachment: line.attachment_url || "",
              uploadedFiles: [],
              isChecked: false,
            }))
          };
          newCategories.push(jobObject);
        } else {
          // If job type not found
          jobObject = {
            id: jobValue,
            name: `Category ${jobValue}`,
            rows: [
              {
                billingtype: "",
                elements: "",
                remarks: "",
                description: "",
                unitQuantity: "",
                unitRatePrice: "",
                netTotal: "",
                attachment: "",
                uploadedFiles: [],
                isChecked: false,
              }
            ]
          };
          newCategories.push(jobObject);
        }
      } else {
        // No data or chargelines in create mode
        jobObject = {
          id: jobValue,
          name: `Category ${jobValue}`,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        };
        newCategories.push(jobObject);
      }

      console.log("new categories...", jobObject.rows);
    });

    setAllCategories(newCategories);
  }, [selectedJobs, data?.job_id]);



  const fetchSuggestions = async (searchTerm = "", rowIndex, index, projectId) => {
    try {
      setSuggestionsMap([]);

      // const response = await axios.get(
      //   `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${projectId}`,
      //   {
      //     params: {
      //       term: searchTerm
      //     }
      //   }
      // );

      const response = await axiosInstance.get(
        `/project_based/getchargecodes/${projectId}`,
        {
          params: {
            term: searchTerm
          }
        }
      );

      if (response.data?.chargecodes) {

        const newSuggestions = response.data?.chargecodes || [];
        setSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {}; // initialize if empty
          updated[index][rowIndex] = newSuggestions;
          console.log("Updated suggestionsMap:", updated);
          return updated;
        });

        setShowSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch suggestions", err);

      setSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = []; // clear only that one
        return updated;
      });

      setShowSuggestionsMap(prev => ({
        ...prev,
        [`${index}_${rowIndex}`]: false,
      }));
    }
  };

  const calculateCategoryTotals = (category) => {
    const totals = {
      quantity: 0,
      rate: 0,
      netValue: 0
    };

    category.rows.forEach(row => {
      totals.quantity += parseFloat(row.unitQuantity) || 0;
      totals.rate += parseFloat(row.unitRatePrice) || 0;
      totals.netValue += parseFloat(row.netTotal) || 0;
    });

    return totals;
  };



  return (
    <div style={{ display: 'flex' }}>
      <div className="job-popup-overlay">
        <div className="job-popup-wrapper">
          <div className="showpopup-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem' }}>
            <div className="showpopup-header-left">
              <p style={{ fontWeight: '600', fontSize: '14px' }}>Create Job</p>
            </div>
            <div className="showpopup-header-right" style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={onClose}
                style={{
                  width: '100px',
                  height: '40px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  backgroundColor: '#f5f5f5',
                  color: '#333',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease'
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => handleSubmit("submit")}
                style={{
                  width: '100px',
                  height: '40px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  backgroundColor: '#19324C',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease'
                }}
              >
                Submit
              </button>
            </div>

          </div>
          <div className='jobs_popup_project' style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            padding: '15px',
            backgroundColor: '#FFFFFF',
            borderRadius: '16px',

          }}>
            <div className='jobs_popup_content' style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '20px',
              padding: '0',
              alignItems: 'end'
            }}>
              {/* Project Input with Autocomplete */}
              <div className="jobs-filter-field">
                <p className="jobs-filter-text">Project <span style={{ color: 'red' }}>*</span></p>
                <AsyncSelect
                  isDisabled={true}
                  cacheOptions
                  defaultOptions
                  loadOptions={loadProjectOptions}
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setProjectInput(selectedOption.label);
                      setFormData({
                        ...formData,
                        project_id: selectedOption.value,
                        project_name: selectedOption.label
                      });
                      setselectedproject(selectedOption.value);
                      setselectedprojectId(selectedOption.value);
                    } else {
                      // Handle clear action
                      setProjectInput('');
                      setFormData({
                        ...formData,
                        project_id: '',
                        project_name: ''
                      });
                      setselectedproject('');
                      setselectedprojectId('');
                    }
                  }}
                  value={projectInput ? {
                    label: projectInput,
                    value: formData.project_id
                  } : null}
                  placeholder="Search project..."
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: '44px',
                      borderRadius: '12px',
                      fontSize: '14px',
                      width: '100%',
                      borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                      boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                      '&:hover': {
                        borderColor: '#454CF2'
                      }
                    }),
                    container: (base) => ({
                      ...base,
                      width: '100%'
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 999,
                      fontSize: '13px',
                      marginTop: '4px',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                      color: '#333',
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee',
                      '&:active': {
                        backgroundColor: '#f2f2f2'
                      }
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      padding: '8px'
                    }),
                    clearIndicator: (base) => ({
                      ...base,
                      padding: '8px'
                    })
                  }}
                />
              </div>
              <div className="jobs-filter-field" ref={dropdownRef}>
                <p className="jobs-filter-text">Job type <span style={{ color: 'red' }}>*</span></p>
                <div className="custom-multiselect">
                  <div
                    className="jobs-type-filter-dropdown"
                    onClick={toggleJobDropdown}
                  >
                    {selectedJobs.length > 0
                      ? jobOptions.find(j => j.value === selectedJobs[0])?.label || "Select Jobs"
                      : "Select Jobs"}
                    <span className="dropdown-arrow">▼</span>
                  </div>

                  {isJobDropdownOpen && (
                    <div className="multiselect-options">
                      {jobOptions.map(job => {
                        const isSelected = selectedJobs.includes(Number(job.value));
                        const isDisabled = selectedJobs.length > 0 && !isSelected;

                        return (
                          <label key={job.id} className={`multiselect-option ${isDisabled ? 'disabled' : ''}`}>
                            <input
                              type="checkbox"
                              checked={isSelected}
                              // disabled={isDisabled}
                              disabled={isEdit || isDisabled}
                              onChange={() => handleJobCheckboxChange(Number(job.value))}
                            />
                            {job.label}
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
              <div className="jobs-filter-field" style={{ display: 'grid' }}>
                <p className="jobs-filter-text">Date <span style={{ color: 'red' }}>*</span></p>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <input className="jobs-filter-date" type='date' alt='' value={formData.job_created_date}
                    onChange={handleDateChange} />

                </div>
              </div>
            </div>
            <div className='jobs_popup_jobs_cards'>
              <p className="jobs-filter-cards-text">Jobs Cards:</p>
              <div className="job_card_list">
                {selectedJobs.map((jobId, index) => {
                  const job = jobOptions.find(j => j.value === jobId);
                  return (
                    <div key={index} className="job_card_item">
                      <span>{job ? job.label : jobId}</span>
                      <button className="job_card_remove" onClick={() => handleRemoveJob(jobId)}>×</button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="invoice_popup_categories">
            {allCategories.map((category, index) => {
              const totals = calculateCategoryTotals(category);
              const jobType = jobOptions.find(job => job.value === category.id);
              return (
                <div key={category.id} className="invoice_popup_outercategory">
                  <div className="invoice_popup_category_header">
                    <div className="category_name_left">
                      <span className="category_name">
                        Job Type -  {jobType ? jobType.label : category.name}
                      </span>
                    </div>
                    <div className="category_name_right">
                      <span className="category_name_quantity">
                        Quantity : <span className="number_highlight">{totals.quantity.toFixed(2)}</span>
                      </span>
                      <img src={small_line} alt="" />
                      <span className="category_name_rate">
                        Rate : <span className="number_highlight">{totals.rate.toFixed(2)}</span>
                      </span>
                      <img src={small_line} alt="" />
                      <span className="category_name_netvalue">
                        Net Value : <span className="number_highlight">{totals.netValue.toFixed(2)}</span>
                      </span>
                    </div>
                  </div>

                  <div className="invoice_popup_category_subheader">
                    <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                      <div className="table-container">
                        <table className="invoice_table">
                          <thead>
                            <tr>
                              {/* <th>
                            <input
                                type="checkbox"
                                style={{
                                width: "14px",
                                height: "14px",
                                borderRadius: "2px",
                                }}
                            />
                            </th> */}

                              <th>CHARGE CODE</th>
                              {/* <th>ELEMENTS</th> */}
                              {/* <th>REMARKS</th> */}
                              <th>DESCRIPTION OF CHARGES</th>
                              <th>UNIT OF QUANTITY</th>
                              <th>UNIT RATE PRICE</th>
                              <th>NET TOTAL</th>
                              <th>ATTACHMENT</th>
                            </tr>
                          </thead>
                          <tbody>
                            {category.rows.map((row, lineindex) => (
                              <tr key={lineindex}>
                                {/* <td>
                                <input
                                type="checkbox"
                                checked={row.isChecked || false}
                                onChange={(e) => handleCheckboxChange(e, category.id, lineindex)}
                                />
                            </td> */}
                                <td style={{ position: "relative" }}>
                                  <input
                                    type="text"
                                    // value={inputValues[index]?.[lineindex] || ""}
                                    value={inputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      handleInputChange(e, index, lineindex, "chargecode");
                                      setInputValues((prev) => ({
                                        ...prev,
                                        [index]: {
                                          ...prev[index],
                                          [lineindex]: val,
                                        },
                                      }));
                                      fetchSuggestions(val, lineindex, index, projectId);
                                    }}
                                    onFocus={() => {
                                      const list = suggestionsMap[index]?.[lineindex] || [];
                                      if (list.length > 0) {
                                        const list = suggestionsMap[index]?.[lineindex] || [];
                                        if (list.length > 0) {
                                          setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                        }
                                      }
                                    }}
                                    onBlur={() => {
                                      setTimeout(() => {
                                        setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                      }, 200);
                                    }}
                                    className="invoice_small_input"
                                    placeholder="Search"
                                  />

                                  {showSuggestionsMap[`${index}_${lineindex}`] && suggestionsMap[index]?.[lineindex]?.length > 0 && (
                                    <ul
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        backgroundColor: "white",
                                        border: "1px solid #ccc",
                                        zIndex: 999,
                                        maxHeight: "150px",
                                        overflowY: "auto",
                                        margin: 0,
                                        padding: 0,
                                        listStyle: "none",
                                      }}
                                    >
                                      {suggestionsMap[index]?.[lineindex].map((item) => (
                                        <li
                                          key={item.value}
                                          onMouseDown={() => {
                                            const selected = item.label;
                                            const chargeId = item.value;

                                            setInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: selected,
                                              },
                                            }));

                                            setSelectedChargeIds((prev) => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: chargeId
                                            }));

                                            handleInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                            setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));


                                            // ✨ NEW PART: split and set description separately ✨
                                            const splitParts = selected.split("-");
                                            const chargeCodeOnly = splitParts[0] || "";
                                            const descriptionOnly = splitParts.slice(1).join("-") || "";


                                            // Update charge code field value (CT002)
                                            setInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: chargeCodeOnly,
                                              },
                                            }));

                                            handleInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                            // Update description field value (TestCharge)
                                            handleInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");
                                          }}
                                          style={{
                                            padding: "8px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          {item.label}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </td>
                                {/* <td>
                                <input
                                type="text"
                                value={row.elements}
                                onChange={(e) => handleInputChange(e, category.id, index, "elements")}
                                className="invoice_small_input"
                                />
                            </td> */}
                                {/* <td>
                                <input
                                type="text"
                                value={row.remarks}
                                onChange={(e) => handleInputChange(e, index, lineindex, "remarks")}
                                className="invoice_small_input"
                                />
                            </td> */}

                                <td>
                                  <input
                                    type="text"
                                    value={row.description}
                                    onChange={(e) => handleInputChange(e, index, lineindex, "description")}
                                    className="invoice_small_input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.unitQuantity}
                                    onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                    className="invoice_small_input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.unitRatePrice}
                                    onChange={(e) => handleInputChange(e, index, lineindex, "unitRatePrice")}
                                    className="invoice_small_input"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.netTotal}
                                    readOnly
                                    className="invoice_small_input"
                                  />
                                </td>
                                <td>
                                  <div className="file_upload_wrapper">
                                    {!row.uploadedFiles || row.uploadedFiles.length === 0 ? (
                                      row.attachment ? (
                                        <div className="download_attachment_section" >
                                          <button
                                            className="download_btn"
                                            onClick={() => window.open(row.attachment, '_blank')}
                                          >
                                            <img src={download_arrow} alt="Download" className="download_icon" />
                                            <span className="download_text">Download</span>
                                          </button>
                                          <button
                                            className="remove_file_btn"
                                            onClick={() => handleRemoveAttachment(category.id, index, lineindex)}
                                          >
                                            ⨉
                                          </button>
                                        </div>
                                      ) : (
                                        <label className="file_upload">
                                          <input
                                            type="file"
                                            multiple
                                            onChange={(e) => handleFileUpload(e, category.id, index, lineindex)}
                                            style={{ display: "none" }}
                                          />
                                          <img src={upload_icon} alt="Upload" className="upload_icon" />
                                          <span className="upload_text">Upload</span>
                                        </label>
                                      )
                                    ) : null}

                                    {row.uploadedFiles && row.uploadedFiles.length > 0 && (
                                      <div className="uploaded_files_list">
                                        {row.uploadedFiles.map((file, fileIndex) => (
                                          <div key={fileIndex} className="uploaded_file_item">
                                            <div className="file_info">
                                              <img
                                                src={
                                                  file.name.match(/\.(xls|xlsx)$/i)
                                                    ? excel_icon
                                                    : upload_icon
                                                }
                                                alt="File type"
                                                className="file_type_icon"
                                              />
                                              <span className="file_name">{file.name}</span>
                                            </div>
                                            <button
                                              className="remove_file_btn"
                                              onClick={() => handleRemoveFile(category.id, index, lineindex, fileIndex)}
                                            >
                                              ⨉
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                </td>

                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div className="static-delete-container">
                          {category.rows.map((row, lineindex) => (
                            <div key={lineindex} className="static-delete-btn">
                              <button onClick={() => deleteRow(category.id, lineindex)}>
                                <img src={delete_icon} alt="Delete" className="delete_icon" />
                              </button>
                            </div>
                          ))}
                        </div>

                      </div>


                      <div
                        className="add_new_row"
                        onClick={() => addRow(index)}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="add_new_row_popup">
                          <img src={plus_icon} alt="" />
                          Add Row
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateJobs
